import { SET_TRACKING_STATE } from './tracking.types';
import { AppDispatch } from '../store';

export const trackingStateData = (stateData: any) => (dispatch: AppDispatch) => {
  dispatch({
    type: SET_TRACKING_STATE,
    payload: stateData,
  });
};

